// Pushes an `email_click` event to the GTM dataLayer when a user taps an
// email link on a landing page. Use as the onClick handler for any
// `<a href="mailto:...">` element.

export function trackEmailClick(pageId: string, email: string) {
  if (typeof window === "undefined") return;
  const w = window as unknown as { dataLayer?: Array<Record<string, unknown>> };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: "email_click",
    page_id: pageId,
    email,
  });
}
